import {rpAppLink} from "@pg-mono/rp-routes";
import {areaFormat, dateTimeFormat, floorFormat, floorsFormat, formatDate, priceFormat, priceM2Format, quarterToRomanNumerals} from "@pg-mono/string-utils";

import {OfferType} from "../../offer/types/OfferType";
import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {getPropertyPlanAltText} from "../../property/utils/get_property_plan_modal_title";
import {getCurrency} from "../../utils/get_currency";
import {getShowPrice} from "../../utils/get_show_price";
import {getThumbnailLink} from "../../utils/get_thumbnail_link";
import {IPersonalizedPropertyCard} from "../types/IPersonalizedHomepage";

interface IOptions {
    shouldHidePrices: boolean;
}

export const mapPropertyDetailToPersonalized = (property: IPropertyDetail, options: IOptions = {shouldHidePrices: true}): IPersonalizedPropertyCard => {
    const offer = property.offer;
    const isHouse = offer.type === OfferType.HOUSE;
    const shouldShowPrice =
        !options.shouldHidePrices &&
        getShowPrice({
            offerPriceVisibility: offer.configuration.price_visibility,
            vendorPriceVisibility: offer.vendor.configuration.price_visibility,
            vendorId: offer.vendor.id
        });

    const hasVisiblePrice = shouldShowPrice && typeof property.price === "number" && property.price > 0;

    return {
        id: `recently-viewed-property-${property.id}`,
        offerName: offer.address || offer.name,
        addressLine: [
            [offer.name, property.number ? `${isHouse ? "Dom" : "Mieszkanie"} nr ${property.number}` : null].filter(Boolean).join(", "),
            offer.vendor.name
        ]
            .filter(Boolean)
            .join(" | "),
        areaLabel: areaFormat(property.area, {precision: 2}) || `${property.area} m²`,
        roomsLabel: `${property.rooms}`,
        floorTitle: isHouse ? "Piętra" : "Piętro",
        floorLabel: isHouse ? floorsFormat(property.floors) || `${property.floors}` : floorFormat(property.floor) || `${property.floor}`,
        priceLabel: hasVisiblePrice
            ? priceFormat(property.price as number, {unit: getCurrency({currency: offer.currency})}) || "Zapytaj o cenę"
            : "Zapytaj o cenę",
        pricePerSquareMeterLabel:
            hasVisiblePrice && property.price_m2 > 0
                ? (priceM2Format(property.price_m2, {precision: 2, unit: getCurrency({currency: offer.currency})}) ?? null)
                : null,
        deliveryLabel: getDeliveryLabel(property.construction_end_date),
        // Base-url thumbnails first (the new API sends `*_url` and nulls the sized
        // objects); the legacy fields stay as fallbacks for the transition period.
        imageUrl:
            getThumbnailLink(offer.main_image_url, 440, 248) ||
            offer.main_image?.m_img_440x248 ||
            property.external_plan_url ||
            getThumbnailLink(property.plan_image_pages[0]?.image_url, 375, 250) ||
            property.plan_image_pages[0]?.image?.p_img_375x250 ||
            getThumbnailLink(property.plan_image_url, 375, 250) ||
            property.plan_image?.p_img_375x250 ||
            "",
        imageAlt: getPropertyPlanAltText(offer.name, property),
        href: rpAppLink.property.detail.base({
            vendorSlug: offer.vendor.slug,
            offerSlug: offer.slug,
            offerId: offer.id,
            propertyId: property.id
        }),
        source: "api"
    };
};

/** "2023-09-30" → "III kw. 2023"; properties already delivered keep the historical quarter. */
const getDeliveryLabel = (constructionEndDate: string | null): string | null => {
    if (!constructionEndDate || Number.isNaN(Date.parse(constructionEndDate))) {
        return null;
    }

    const quarterLabel = formatDate(constructionEndDate, dateTimeFormat.quarter);

    return quarterLabel ? quarterToRomanNumerals(quarterLabel) : null;
};
import {rpAppLink} from "@pg-mono/rp-routes";
import {areaFormat, dateTimeFormat, floorFormat, floorsFormat, formatDate, priceFormat, priceM2Format, quarterToRomanNumerals} from "@pg-mono/string-utils";

import {OfferType} from "../../offer/types/OfferType";
import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {getPropertyPlanAltText} from "../../property/utils/get_property_plan_modal_title";
import {getCurrency} from "../../utils/get_currency";
import {getShowPrice} from "../../utils/get_show_price";
import {getThumbnailLink} from "../../utils/get_thumbnail_link";
import {IPersonalizedPropertyCard} from "../types/IPersonalizedHomepage";

interface IOptions {
    shouldHidePrices: boolean;
}

export const mapPropertyDetailToPersonalized = (property: IPropertyDetail, options: IOptions = {shouldHidePrices: true}): IPersonalizedPropertyCard => {
    const offer = property.offer;
    const isHouse = offer.type === OfferType.HOUSE;
    const shouldShowPrice =
        !options.shouldHidePrices &&
        getShowPrice({
            offerPriceVisibility: offer.configuration.price_visibility,
            vendorPriceVisibility: offer.vendor.configuration.price_visibility,
            vendorId: offer.vendor.id
        });

    const hasVisiblePrice = shouldShowPrice && typeof property.price === "number" && property.price > 0;

    return {
        id: `recently-viewed-property-${property.id}`,
        offerName: offer.address || offer.name,
        addressLine: [
            [offer.name, property.number ? `${isHouse ? "Dom" : "Mieszkanie"} nr ${property.number}` : null].filter(Boolean).join(", "),
            offer.vendor.name
        ]
            .filter(Boolean)
            .join(" | "),
        areaLabel: areaFormat(property.area, {precision: 2}) || `${property.area} m²`,
        roomsLabel: `${property.rooms}`,
        floorTitle: isHouse ? "Piętra" : "Piętro",
        floorLabel: isHouse ? floorsFormat(property.floors) || `${property.floors}` : floorFormat(property.floor) || `${property.floor}`,
        priceLabel: hasVisiblePrice
            ? priceFormat(property.price as number, {unit: getCurrency({currency: offer.currency})}) || "Zapytaj o cenę"
            : "Zapytaj o cenę",
        pricePerSquareMeterLabel:
            hasVisiblePrice && property.price_m2 > 0
                ? (priceM2Format(property.price_m2, {precision: 2, unit: getCurrency({currency: offer.currency})}) ?? null)
                : null,
        deliveryLabel: getDeliveryLabel(property.construction_end_date),
        // Base-url thumbnails first (the new API sends `*_url` and nulls the sized
        // objects); the legacy fields stay as fallbacks for the transition period.
        imageUrl:
            getThumbnailLink(offer.main_image_url, 440, 248) ||
            offer.main_image?.m_img_440x248 ||
            property.external_plan_url ||
            getThumbnailLink(property.plan_image_pages[0]?.image_url, 375, 250) ||
            property.plan_image_pages[0]?.image?.p_img_375x250 ||
            getThumbnailLink(property.plan_image_url, 375, 250) ||
            property.plan_image?.p_img_375x250 ||
            "",
        imageAlt: getPropertyPlanAltText(offer.name, property),
        href: rpAppLink.property.detail.base({
            vendorSlug: offer.vendor.slug,
            offerSlug: offer.slug,
            offerId: offer.id,
            propertyId: property.id
        }),
        source: "api"
    };
};

/** "2023-09-30" → "III kw. 2023"; properties already delivered keep the historical quarter. */
const getDeliveryLabel = (constructionEndDate: string | null): string | null => {
    if (!constructionEndDate || Number.isNaN(Date.parse(constructionEndDate))) {
        return null;
    }

    const quarterLabel = formatDate(constructionEndDate, dateTimeFormat.quarter);

    return quarterLabel ? quarterToRomanNumerals(quarterLabel) : null;
};
